import React, { memo, useCallback } from 'react';
import type { TabItem } from '@/components/custom/arito/form/shared-types';
import { BottomBar } from '@/components/custom/arito/form/bottom-bar';
import { AritoForm } from '@/components/custom/arito/form/form';
import { AritoIcon } from '@/components/custom/arito/icon';
import AritoModal from '@/components/custom/arito/modal';

interface ModalFormProps {
  title: string;
  headerFields: React.ReactNode;
  tabs: React.ReactNode[] | TabItem[] | undefined;
  open: boolean;
  onClose: (show: boolean) => void;
  formMode: 'add' | 'edit' | 'view';
  initialData: any;
  handleSubmit: (data: any) => void;
}

export const ModalForm = memo(
  ({ title, headerFields, tabs, open, onClose, formMode, initialData, handleSubmit }: ModalFormProps) => {
    const handleClose = useCallback(() => onClose(false), [onClose]);

    return (
      <AritoModal open={open} onClose={handleClose} title={title} titleIcon={<AritoIcon icon={699} />} maxWidth='xl'>
        <div className='flex size-full flex-col overflow-hidden'>
          <div className='max-h-[calc(100vh-120px)] flex-1 overflow-auto'>
            <AritoForm<any>
              mode={formMode}
              initialData={initialData || {}}
              hasAritoActionBar={false}
              className='!static !w-full'
              onSubmit={handleSubmit}
              onClose={handleClose}
              headerFields={headerFields}
              tabs={tabs}
            />
          </div>

          <BottomBar mode={formMode} onSubmit={() => {}} onClose={handleClose} />
        </div>
      </AritoModal>
    );
  }
);

ModalForm.displayName = 'ModalForm';
